import { Stack } from '@mui/material'
import React from 'react'

import { Balance, GeotokensAllowance, MinterAllowance } from '../../Components'

interface Props {
  geotokensAllowance?: boolean
}

const AllowanceBalance: React.FC<Props> = (props) => {
  const { geotokensAllowance } = props
  return (
    <Stack direction="row" spacing={1}>
      {geotokensAllowance ? <GeotokensAllowance size="small" /> : <MinterAllowance size="small" />}
      <Balance size="small" />
    </Stack>
  )
}

export default AllowanceBalance
